import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('FIXEDFORMAT_DATA_URI_VIEWER', LOG_LEVELS.DEBUG);
class FixedFormatDataUriViewer extends Component {
    render() {
        log.debug('render(): ', this.props);
        return (
            <div>
                {
                    this.props.data ?
                        (<div><textarea rows="10" defaultValue={this.props.data}></textarea><br /><a className="button primary" href={"data:text/plain,"+encodeURIComponent(this.props.data)} download={this.props.filename}>Download {this.props.filename}</a></div>)
                        :
                        ( <div><span>Loading {this.props.filename}</span></div>)
                }
            </div>
        );
    }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {};
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(FixedFormatDataUriViewer);